import React, { useRef, useState } from 'react';

import {
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    InputGroup,
} from '@chakra-ui/react';
import { Field, FieldProps } from 'formik';

import { CustomText } from '@components/Custom-text';

interface FormControlFileFieldProps {
    name: string;
    label: string;
    placeholder: string;
    isDisabled?: boolean;
    isRequired?: boolean;
}

const FormControlFileField: React.FC<FormControlFileFieldProps> = ({
    name,
    label,
    placeholder,
    isDisabled,
    isRequired,
}) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [file, setFile] = useState<File | null>(null);

    return (
        <Field name={name}>
            {({ field, form: { touched, errors, setFieldValue } }: FieldProps) => {
                const isInvalid = !!errors[field.name] && touched[field.name];
                return (
                    <FormControl isInvalid={Boolean(isInvalid)} width="100%">
                        <Flex>
                            <FormLabel>
                                <Heading color="titleText" size="xs" as="h6">
                                    {label}
                                </Heading>
                            </FormLabel>
                            {isRequired ? (
                                <Heading color="red" size="xs" ml={-2}>
                                    *
                                </Heading>
                            ) : null}
                        </Flex>
                        <InputGroup width="100%">
                            <Input
                                id={name}
                                name={name}
                                ref={inputRef}
                                type="file"
                                disabled={isDisabled}
                                style={{ display: 'none' }}
                                accept=".pdf,.docx"
                                data-testid="fileInput"
                                onChange={e => {
                                    setFile(e.target.files ? e.target.files[0] : null);
                                    setFieldValue(name, e.target.files ? e.target.files[0] : null);
                                }}
                            />
                            <FormLabel htmlFor={name} width="100%" margin={0}>
                                <Flex
                                    width="100%"
                                    height="2.5rem"
                                    border={isInvalid ? 2 : 1}
                                    px="1rem"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    borderColor={isInvalid ? 'red.500' : 'inherit'}
                                    borderStyle="solid"
                                    borderRadius="0.375rem"
                                >
                                    <CustomText
                                        color={file?.name !== undefined ? 'titleText' : 'subText'}
                                        size="md"
                                        dataTestid="fileOutput"
                                    >
                                        {file ? file.name : placeholder}
                                    </CustomText>
                                    <CustomText size="md" color="primary.light" cursor="pointer">
                                        Browse
                                    </CustomText>
                                </Flex>
                            </FormLabel>
                        </InputGroup>
                        <FormErrorMessage>
                            <CustomText size="xs" color="red.500">
                                {String(errors[field.name])}
                            </CustomText>
                        </FormErrorMessage>
                    </FormControl>
                );
            }}
        </Field>
    );
};

export default FormControlFileField;
